import { useState, useEffect } from "react";

const BASE = "/whatsapp/v2/demo-runtime";

const _s = {
  wrap:    { marginTop: 20, padding: "16px", border: "1px solid #e5e7eb", borderRadius: 8, background: "#f9fafb" },
  label:   { fontSize: 13, fontWeight: 600, marginBottom: 10, color: "#374151" },
  row:     { display: "flex", gap: 8, marginBottom: 10, flexWrap: "wrap" },
  input:   { flex: 1, minWidth: 180, padding: "7px 10px", border: "1px solid #d1d5db", borderRadius: 6, fontSize: 13, fontFamily: "monospace" },
  btn:     (active) => ({ padding: "7px 16px", background: active ? "#1d4ed8" : "#d1d5db", color: "#fff", border: "none", borderRadius: 6, cursor: active ? "pointer" : "not-allowed", fontWeight: 700, fontSize: 13 }),
  codeBox: { background: "#1e1b4b", color: "#a5f3fc", borderRadius: 8, padding: "16px 20px", textAlign: "center", marginBottom: 8 },
  code:    { fontSize: 28, fontWeight: 700, letterSpacing: 4, fontFamily: "monospace" },
  hint:    { fontSize: 12, color: "#6b7280", lineHeight: 1.6 },
  err:     { background: "#fef2f2", border: "1px solid #ef4444", borderRadius: 6, padding: "8px 12px", color: "#dc2626", fontSize: 13, marginBottom: 8 },
};

/**
 * Pairing code section for V2 Demo Runtime.
 * Manages its own phone/code state; clears code when lifecycle goes idle (running→false).
 */
export default function PairingSection({ authAxios, busy, setBusy, running }) {
  const [phone, setPhone]         = useState("");
  const [code, setCode]           = useState(null);
  const [pairingErr, setPairingErr] = useState(null);

  // Clear stale code when session ends (user disconnects or lifecycle terminates).
  useEffect(() => {
    if (!running) { setCode(null); setPairingErr(null); }
  }, [running]);

  const canRequest = !busy && !running && phone.replace(/[^0-9]/g, "").length >= 7;

  const handleRequest = async () => {
    setBusy(true); setCode(null); setPairingErr(null);
    try {
      const r = await authAxios.post(`${BASE}/pairing-request`, { phone_number: phone });
      const pc = r.data?.pairing_code;
      if (pc) {
        setCode(pc);
      } else {
        // Server returned 200 but no code — extract technical detail for debugging
        const det = r.data?.pairing_error_detail;
        const msg = det?.message || r.data?.reason || "sem código na resposta";
        const suffix = [
          det?.runtime_state && `state=${det.runtime_state}`,
          det?.ws_ready_state != null && `ws=${det.ws_ready_state}`,
          det?.code && `code=${det.code}`,
        ].filter(Boolean).join(" ");
        setPairingErr(`Erro: ${msg}${suffix ? ` [${suffix}]` : ""}`);
      }
    } catch (e) {
      const st = e.response?.status;
      if (st === 400) setPairingErr("Número inválido — formato: 351912345678");
      else if (st === 409) setPairingErr("Sessão já activa — clica DISCONNECT primeiro.");
      else if (st === 403) setPairingErr("Tenant não autorizado.");
      else if (st === 503) setPairingErr("V2 Demo Runtime desactivado.");
      else setPairingErr(`Erro ao solicitar código (HTTP ${st ?? "rede"}) — tenta de novo.`);
    } finally { setBusy(false); }
  };

  return (
    <div style={_s.wrap}>
      <div style={_s.label}>Conectar por código de emparelhamento</div>
      <div style={_s.row}>
        <input
          style={_s.input}
          placeholder="Nº WhatsApp (ex: 351912345678)"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          disabled={busy || running}
        />
        <button onClick={handleRequest} disabled={!canRequest} style={_s.btn(canRequest)}>
          {busy ? "…" : "GERAR CÓDIGO"}
        </button>
      </div>
      {pairingErr && <div style={_s.err}>{pairingErr}</div>}
      {code && (
        <>
          <div style={_s.codeBox}>
            <div style={_s.code}>{code}</div>
          </div>
          <div style={_s.hint}>
            No WhatsApp: Definições → Dispositivos vinculados → Vincular dispositivo → Vincular com número de telefone → introduz o código acima.
          </div>
        </>
      )}
    </div>
  );
}
